import React from 'react';
import { Table, Card, Progress, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './Disk.module.scss';

const FilesystemInfo = ({ filesystemInfo }) => {
  // 파일시스템 정보 파싱
  const parseFilesystemInfo = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const filesystems = [];
      const lines = data.trim().split('\n');
      
      // 헤더 라인 건너뛰기
      const dataLines = lines.slice(1);
      
      dataLines.forEach(line => {
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 6) {
          const filesystem = parts[0];
          const type = parts[1];
          const size = parts[2];
          const used = parts[3];
          const avail = parts[4];
          const usePercent = parseInt(parts[5].replace('%', ''), 10);
          const mountPoint = parts[6];
          
          filesystems.push({
            filesystem,
            type,
            size,
            used,
            avail,
            usePercent,
            mountPoint,
            key: `${filesystem}-${mountPoint}`
          });
        }
      });
      
      return filesystems;
    } catch (error) {
      console.error('Error parsing filesystem info:', error);
      return [];
    }
  };

  const filesystems = parseFilesystemInfo(filesystemInfo);

  return (
    <Card 
      title={
        <div>
          파일시스템 사용량
          <Tooltip title="마운트된 파일시스템의 사용량 정보입니다.">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      } 
      className={styles.diskCard}
    >
      <Table 
        dataSource={filesystems}
        rowKey="key"
        pagination={false}
        columns={[
          { title: '파일시스템', dataIndex: 'filesystem', key: 'filesystem' },
          { title: '유형', dataIndex: 'type', key: 'type' },
          { title: '크기', dataIndex: 'size', key: 'size' },
          { title: '사용됨', dataIndex: 'used', key: 'used' },
          { title: '가용', dataIndex: 'avail', key: 'avail' },
          { 
            title: '사용률', 
            dataIndex: 'usePercent', 
            key: 'usePercent',
            render: (percent) => (
              <div>
                <Progress 
                  percent={percent} 
                  size="small" 
                  status={percent > 90 ? 'exception' : percent > 75 ? 'warning' : 'normal'}
                />
              </div>
            )
          },
          { title: '마운트 포인트', dataIndex: 'mountPoint', key: 'mountPoint' }
        ]}
      />
    </Card>
  );
};

export default FilesystemInfo;